import React, { useEffect, useState } from "react";
import { Card } from "../../../common";
import { CompanyCard } from "./CompanyCard";
import { useSelector } from "react-redux";
import {
  useGetIndividualQuery,
} from "../../../../store/Company/companyApiSlice";
export const CompanyList = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { token } = useSelector((state) => state.auth);

  const [individualData, setIndividualData] = useState();
  const userIndividual = userInfo?.individual[0]?.individualID;
  const { data } = useGetIndividualQuery({
    individualID: userIndividual,
    token,
  });
  useEffect(() => {
    if (data) {
      setIndividualData(data);
      localStorage.setItem('userindividualID', data?.individualID)
    }
  }, [data])

  const claimedCompanies = individualData?.individual?.filter(
    (company) => company.companyID.claimed
  );


  return (
    <Card classes="w-full md:col-start-1 md:col-end-10 ">
      <h3 className="text-left text-f24 text-primary font-bold">
        Manage Companies
      </h3>
      <p className="text-left text-f16 text-secondarytwo mb-4">
        Manage all your companies in one place.
      </p>
      <div className="h-[calc(100vh-92px)] overflow-scroll overflow-x-hidden flex flex-wrap gap-3">
        {claimedCompanies?.map((company, index) => (
          <CompanyCard company={company} key={index} />
        ))}
      </div>
    </Card>
  );
};
